'use client'

import Link from 'next/link'
import { ArrowLeft } from 'lucide-react'
import { useSidebar } from 'fumadocs-ui/components/sidebar/base'
import type { DocsLocale } from '@/lib/docs-i18n'
import { DOCS_CHROME } from '@/lib/docs-i18n'
import { DocsBrandRow } from '@/components/docs/DocsBrandRow'

/**
 * Sidebar header — logo + "/ Docs" and dashboard back-link. On mobile the brand
 * row is hidden (see docs-theme.css); DocsMobileSubNav shows the same brand.
 */
export function DocsSidebarBrand({ locale }: { locale: DocsLocale }) {
  return (
    <div className="docs-sidebar-brand w-full min-w-0">
      <DocsBrandRow locale={locale} className="docs-sidebar-brand-row w-full" />
      <DocsSidebarDashboardLink locale={locale} className="mt-1.5" />
    </div>
  )
}

export function DocsSidebarDashboardLink({
  locale,
  className = '',
}: {
  locale: DocsLocale
  className?: string
}) {
  const chrome = DOCS_CHROME[locale]

  return (
    <Link
      href="/dashboard"
      className={`docs-sidebar-dashboard-link inline-flex items-center gap-1.5 text-body-sm ${className}`.trim()}
    >
      <ArrowLeft className="size-4 shrink-0" aria-hidden />
      {chrome.dashboard}
    </Link>
  )
}

export function DocsSidebarNavTitle({ locale }: { locale: DocsLocale }) {
  const { mode } = useSidebar()
  return mode === 'full' ? <DocsSidebarBrand locale={locale} /> : null
}

export function DocsMobileSidebarBanner({ locale }: { locale: DocsLocale }) {
  const { mode } = useSidebar()
  return mode === 'drawer' ? <DocsSidebarDashboardLink locale={locale} /> : null
}
